import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { NOTIFICATION_REQUEST } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, PUT, DELETE } = HTTP_METHODS;
const {
  GET_HRX_NOTIFICATION,
  POST_HRX_NOTIFICATION,
  PUT_NOTIFICATION_STATUS,
  PUT_HRX_NOTIFICATION,
  DELETE_HRX_NOTIFICATION
} = NOTIFICATION_REQUEST;

export const notificationApi = createApi({
  reducerPath: 'notificationApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getHRXNotification: builder.query({
      query: (data) => ({ url: `${GET_HRX_NOTIFICATION}${buildQueryString(data)}`, method: GET })
    }),
    addHRXNotification: builder.mutation({
      query: (data) => ({ url: POST_HRX_NOTIFICATION, method: POST, data })
    }),
    updateNotificationReadStatus: builder.mutation({
      query: (data) => ({
        url: `${PUT_NOTIFICATION_STATUS}/${data.id}`,
        method: PUT,
        data: data.data
      })
    }),
    deleteHRXNotification: builder.mutation({
      query: (id) => ({
        url: `${DELETE_HRX_NOTIFICATION}/${id}`,
        method: DELETE
      })
    }),
    editHRXNotification: builder.mutation({
      query: (data) => ({
        url: `${PUT_HRX_NOTIFICATION}/${data.id}`,
        method: PUT,
        data: data.data
      })
    })
  })
});

export const {
  useGetHRXNotificationQuery,
  useAddHRXNotificationMutation,
  useEditHRXNotificationMutation,
  useDeleteHRXNotificationMutation,
  useUpdateNotificationReadStatusMutation
} = notificationApi;
